module.exports = __webpack_public_path__ + "img/icon_index_qiye.99dcf67d.png";